import React, { useState } from "react";
import { videoArray } from "../Videos";
import Modal from "react-bootstrap/Modal"; // Assuming you're using Bootstrap Modal
import "./Work.scss";

const Work = () => {
  const [selectedVideo, setSelectedVideo] = useState(null); // Track selected video
  const [showModal, setShowModal] = useState(false); // Track modal visibility

  const isEmbeddable = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === "https:" && (
        (["youtube.com", "www.youtube.com"].includes(parsed.hostname) &&
          /^\/embed\/[\w-]+$/.test(parsed.pathname)) ||
        (parsed.hostname === "player.vimeo.com" && /^\/video\/\d+$/.test(parsed.pathname))
      );
    } catch {
      return false;
    }
  };

  // Function to handle when a video is clicked
  const handleVideoClick = (video) => {
    if (!video?.youtubeLink) return;
    if (video?.youtubeLink && !isEmbeddable(video.youtubeLink)) {
      window.open(video.youtubeLink, "_blank", "noopener,noreferrer");
      return;
    }

    setSelectedVideo(video); // Set the clicked video as the selected one
    setShowModal(true); // Show the modal
  };

  // Function to close the modal
  const handleClose = () => {
    setShowModal(false); // Hide the modal
  };

  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  };

  const renderVideos = () => {
    const videos = [];
    let videoList = videoArray;

    // Loop through videos
    videoList.forEach((vid, index) => {
      videos.push(
        <div
          key={vid.videoTitle}
          className="video-item col-md-6"
          role="button"
          tabIndex={vid.youtubeLink ? 0 : -1}
          aria-label={vid.alt}
          aria-disabled={!vid.youtubeLink}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              handleVideoClick(vid);
            }
          }}
          onClick={() => handleVideoClick(vid)} // Open modal on click
        >
          <div
            className="thumbnail-container"
            style={{
              "--preview-scale": vid.previewScale,
              "--preview-origin": vid.previewOrigin,
            }}
          >
            {isMobile() || !vid.gifSrc ? (
              // Show image on mobile or if no gifSrc is available
              <img
                src={vid.thumbnailSrc || "https://placehold.co/1280x720"}
                alt={vid.alt}
                className={`img-fluid thumbnail-img${isMobile() ? " mobile-thumbnail" : ""}`}
              />
            ) : (
              // Show video on desktop only
              <video
                key={vid.gifSrc}
                src={vid.gifSrc}
                className="vid-thumbnail"
                muted
                preload="metadata"
                loop
                aria-label={vid.alt}
                poster={vid.thumbnailSrc || "https://placehold.co/1280x720"}
                onMouseEnter={(e) => {
                  const preview = e.currentTarget;
                  preview._hovering = true;
                  requestAnimationFrame(() => {
                    if (preview._hovering) {
                      preview.play().catch(() => {});
                    }
                  });
                }}
                onMouseLeave={(e) => {
                  e.target._hovering = false;
                  e.target.pause();
                  e.target.currentTime = 0;
                  e.target.load();
                }}
              />
            )}
          </div>

          <div className="play-button-overlay">
            <i className="bi bi-play-fill"></i>
          </div>
          <div className="video-text d-block d-sm-flex px-5 py-3">
            <h4 className="fs-4">
              {vid.artistName}
              {vid.artistName && vid.videoTitle && " - "}
              <span className="fw-light mx-1">{vid.videoTitle}</span>
            </h4>
          </div>
        </div>,
      );
    });
    return videos;
  };

  return (
    <div className="work-page" id="Work" data-scroll-section>
      <div className="work-page-content">
        <div className="row">{renderVideos()}</div>

        {/* Modal to display the selected video */}
        <Modal
          show={showModal}
          onHide={handleClose}
          dialogClassName="modal-css modal-fullscreen-md-down"
          centered
        >
          <button
            className="btn-close position-absolute bg-white"
            style={{ top: "1rem", right: "1rem", zIndex: 1051, color: "white" }}
            onClick={handleClose}
            aria-label="Close"
          ></button>
          <Modal.Body>
            {selectedVideo?.youtubeLink && (
              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  className="embed-responsive-item"
                  src={`${selectedVideo.youtubeLink}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title={selectedVideo.alt}
                ></iframe>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Work;
